/* unplugin-vue-components disabled */import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=705a5820&lang=scss"

const __exports__ = script;

export default __exports__